import { createSelector } from '../lib/createSelector.js';

const stableArray = Object.freeze([]);
const stableObject = Object.freeze({});

export const jobs = (state) => state.jobs?.jobs;
export const jobLogs = (state) => state.jobs?.jobLogs;
export const recentJobLogs = (state) => state.jobs?.recentJobLogs;
export const jobConfig = (state) => state.jobs?.jobConfig;
export const jobMemory = (state) => state.jobs?.jobMemory;
export const jobLogOutputs = (state) => state.jobs?.jobLogOutputs;
export const userJobAlerts = (state) => state.jobs?.userJobAlerts;

export const jobLogsByJobId = createSelector('jobLogsByJobId', [jobLogs, (_, jobId) => jobId], (jobLogs, jobId) => jobLogs[jobId]);
export const jobConfigByJobId = createSelector('jobConfigByJobId', [jobConfig, (_, jobId) => jobId], (jobConfig, jobId) => jobConfig[jobId]);
export const jobMemoryByJobId = createSelector('jobMemoryByJobId', [jobMemory, (_, jobId) => jobId], (jobMemory, jobId) => (jobMemory || stableObject)[jobId]);
export const jobLogById = createSelector(
  'jobLogById',
  [jobLogs, (_, jobId, __) => jobId, (_, __, jobLogId) => jobLogId], //
  (jobLogs, jobId, jobLogId) => (jobLogs[jobId]?.logs || stableArray).find((n) => n.id === jobLogId)
);
export const jobLogOutputById = createSelector('jobLogOutputById', [jobLogOutputs, (_, jobLogId) => jobLogId], (jobLogOutputs, jobLogId) => jobLogOutputs[jobLogId]);
export const jobById = createSelector('jobById', [jobs, (_, jobId) => jobId], (jobs, jobId) => (jobs || stableArray).find((n) => n.id === jobId));
export const jobIsRunning = createSelector('jobIsRunning', [(state, jobId) => jobLogsByJobId(state, jobId)], (jobLogs) => !!jobLogs?.active);
